var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.321,
    height: 24,
    viewBox: "0 0 30.321 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.802 -20.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M41.123,23.7V37.222a3.212,3.212,0,0,1-3.2,3.2l-5.425,0H14a3.212,3.212,0,0,1-3.2-3.2V23.7A3.212,3.212,0,0,1,14,20.5H37.923a3.212,3.212,0,0,1,3.2,3.2ZM38.351,37.067V23.7a.634.634,0,0,0-.663-.662H14.04a.657.657,0,0,0-.663.662l0,13.371a.657.657,0,0,0,.663.662h5.776a8.868,8.868,0,0,1,3.239-4.053,6.8,6.8,0,0,1,1.366-.74,3.988,3.988,0,0,1,1.326-.234,3.93,3.93,0,0,1,1.561.35,4.414,4.414,0,0,1,1.366.78,9,9,0,0,1,3.082,3.9h5.971a.6.6,0,0,0,.625-.662Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.456,75.806v1.333H35V75.806A1.827,1.827,0,0,1,36.805,74h7.847a1.825,1.825,0,0,1,1.8,1.805Z",
    transform: "translate(-14.786 -32.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.145,29.7A3.884,3.884,0,1,1,39.3,33.582,3.892,3.892,0,0,1,43.145,29.7Z",
    transform: "translate(-17.397 -5.59)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpVideoCall);
export default __webpack_public_path__ + "static/media/np-video-call.1981cfe159d7e72004ed1f2c82ec2b6b.svg";
export { ForwardRef as ReactComponent };